import { tokens } from '../../Common/designTokens'; // added

// Constants for styling
export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "800px",
  bgcolor: tokens.colors.bodyBackgroundColor,
  p: 0,
  borderRadius: "8px",
};

export const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  px: 2,
  py: 1,
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: "15px",
    right: "20px",
    borderBottom: `1px solid ${tokens.colors.bodyBorderColor50}`,
  },
};

/**
 * One tab in an order-entry tab bar. Shared by OrderEntryCore (Bond Order, Bond
 * Characteristic, Bond Ladder, List Order), OrderEntryContainer (the first three) and
 * MAWatchlistPopup, which spreads it and overrides only its own sizing.
 *
 * The selected underline is 2px, not 1px, and that is deliberate. Tab widths come from their
 * labels, so they are fractional, and each tab's left edge is the running total of the ones
 * before it. A 1px border landing on a half-pixel gets antialiased across two device pixels
 * and renders at roughly half strength - which is why the LAST tab looked faded next to the
 * first: it carries the accumulated fractional offset of every tab before it, while the first
 * starts at the bar's own whole-pixel padding. 2px always covers a whole device pixel, so
 * every tab draws the same solid line regardless of where it happens to start.
 *
 * The weight is taken back out through the colour rather than the thickness: primaryA80 is
 * the same blue at 80%, so the line reads lighter while still covering whole pixels. Thinning
 * it back to 1px would bring the uneven fading straight back, which is the one thing this is
 * here to prevent.
 */
export const tabStyle = {
  textTransform: "none",
  fontWeight: 700,
  fontSize: "1.15rem",
  minWidth: "120px",
  "&.Mui-selected": {
    borderBottom: `2px solid ${tokens.palette.primaryA80}`,
    backgroundColor: "transparent",
  },
};

export const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  p: 2,
  borderTop: `1px solid ${tokens.colors.bodyBorderColor50}`,
  mt: "auto",
};

export const inputStyle = {
    bgcolor: "transparent",
    "& .MuiFilledInput-root": {
      bgcolor: tokens.colors.white,
      borderRadius: "8px",
      border: `1px solid ${tokens.colors.bodyBorderColor50}`,
      transition: "border 0.2s ease-in-out, background-color 0.2s ease-in-out",
      "&:focus-within": {
        bgcolor: tokens.colors.white,
      },
      "&:hover": {
        bgcolor: tokens.colors.white,
        border: `1px solid ${tokens.palette.primaryA25 || tokens.palette.primaryA30}`,
      },
      // Completely remove the disabled state styling
      "&.Mui-disabled": {
        opacity: 1,
        backgroundColor: tokens.colors.disabledWhite,
        border: `1px solid ${tokens.colors.bodyBorderColor50}`,
        cursor: "not-allowed",
        "& input": {
          cursor: "not-allowed",
          color: tokens.colors.disabledFontColour,               // use disabled token
          WebkitTextFillColor: tokens.colors.disabledFontColour, // use disabled token
          '&::selection': {
            backgroundColor: "transparent"
          }
        },
        "& .MuiSelect-select": {
          cursor: "not-allowed",
          backgroundColor: tokens.colors.white,
          color: tokens.colors.disabledFontColour,               // ensure select disabled text uses disabled token
        }
      },
      "&.Mui-error": {
        border: `1px solid ${tokens.palette.danger}`,
      },
      paddingTop: "10px",
    },
    "& .MuiInputLabel-root": {
      // color: "rgba(255, 255, 255, 0.7)",
      transform: "translate(12px, 16px) scale(1)",
      "&.Mui-focused": {
        transform: "translate(12px, 7px) scale(0.75)",
      },
      "&.MuiInputLabel-shrink": {
        transform: "translate(12px, 7px) scale(0.75)",
      },
      "&.Mui-disabled": {
        color: tokens.colors.fontColour85,
        opacity: 1,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
    },
    "& .MuiSelect-filled": {
      // bgcolor: tokens.colors.white,
      borderRadius: "8px",
      paddingTop: "10px",
      "&.Mui-disabled": {
        opacity: 1,
        backgroundColor: tokens.colors.white,
        color: tokens.colors.disabledFontColour,
      },
    },
    // Ensure Radio and Checkbox maintain their appearance
    "& .MuiRadio-root.Mui-disabled": {
      color: "inherit",
    },
    "& .MuiCheckbox-root.Mui-disabled": {
      color: "inherit",
    },
  };
  

export const readOnlyFieldStyle = {
  bgcolor: tokens.colors.defaultGridRowColor,
  color: tokens.colors.fontColour,
  border: `1px solid ${tokens.colors.bodyBorderColor50}`,
  borderRadius: "8px",
  p: 1,
  height: "40px",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
};

export const accordionStyle = {
  boxShadow: "none",
  // border: "none",
  border: `1px solid ${tokens.colors.bodyBorderColor50}`,
  borderRadius: "8px",
  "&:before": { display: "none" },
  bgcolor: tokens.colors.defaultGridRowColor,
  mt: 2
};

export const accordionSummaryStyle = {
  minHeight: 48,
  "&.Mui-expanded": {
    minHeight: 48,
  },
};

export const accordionDetailsStyle = {
  padding: 2,
  borderTop: `1px solid ${tokens.colors.bodyBorderColor50}`,
};

export const bottomCloseButtonStyle = {
  display: "flex",
  justifyContent: "center",
  p: 2,
  borderTop: `1px solid ${tokens.colors.bodyBorderColor50}`,
  mt: 2,
};
